<template>
  <page-outline
    :title="$t('Webheader.tracking')"
    :show-filter="tabName === 1 || tabName === 2"
    :show-refresh="tabName === 1 || tabName === 2"
    :show-extract="showExportButton"
    :filter-expanded="displayFilter"
    :refresh-disabled="activateSpinner"
    :extract-disabled="activateSpinner"
    @toggle-filter="toggleFilter"
    @refresh="refreshCurrentTab"
    @extract="exportCurrentTab">
    <template slot="filterContent" v-if="tabName === 1 || tabName === 2">
      <app-panel
        :filters="currentFilterConfig"
        :searchAriaLabel="searchAriaLabel"
        @filter-changed="onFilterChanged"
        @clear-filters="clearCurrentFilters"
        @apply-filters="applyCurrentFilter"
      />


    </template>
    <template slot="navigationTabs" v-if="type != 'BULKDETAILS' && !flagTOOLBOX">
      <!-- Mobile tabs -->
      <div class="d-block d-lg-none">
        <div class="d-flex flex-column">
          <app-button
            v-for="(tab, index) in tabs"
            :key="index"
            :text="$t(tab.translationKey)"
            :variant="tabName === tab.value ? 'primary' : 'light'"
            size="md"
            :block="true"
            custom-class="mb-2"
            :role="'tab'"
            :id="'mobile-tab-' + randomId + '-' + tab.value"
            :aria-selected="tabName === tab.value ? 'true' : 'false'"
            :aria-controls="'tabpanel-' + randomId + '-' + tab.value"
            @click="changeTabName(tab.value)"
          />
        </div>
      </div>
      <!-- Desktop tabs -->
      <div class="d-none d-lg-block">
        <div class="nav nav-tabs nav-fill border-0" role="tablist">
          <button
            v-for="(tab, index) in tabs"
            :key="index"
            :class="[
              'nav-link',
              {'active bg-primary text-white font-weight-bold': tabName === tab.value}
            ]"
            @click="changeTabName(tab.value)"
            @keydown="handleTabKeydown($event, tab.value)"
            :id="'desktop-tab-' + randomId + '-' + tab.value"
            role="tab"
            type="button"
            :aria-selected="tabName === tab.value ? 'true' : 'false'"
            :aria-controls="'tabpanel-' + randomId + '-' + tab.value"
            :tabindex="tabName === tab.value ? '0' : '-1'"
          >
            {{ $t(tab.translationKey) }}
          </button>
        </div>
      </div>
    </template>
    <template slot="pageContent">
      <b-container fluid>
        <nav :aria-label="$t('tracking.breadcrumb')" class="sr-only">
          <ol>
            <li>{{ $t('Webheader.tracking') }}</li>
          </ol>
        </nav>
        <div class="requestsList">
          <div class="mt-0">
            <div>
               <div role="tabpanel" :id="'tabpanel-' + randomId + '-1'" :aria-labelledby="'desktop-tab-' + randomId + '-1'" v-show="tabName === 1" aria-hidden="false">
                <TrackingList
                  :type="TrackType"
                  :id="id"
                  :filters="trackingFilters"
                  :vop-provider-list="vopProviderList"
                  :display-filter="displayFilter"
                  @update-tab="val => trackingFilters.tabName = val">
                </TrackingList>
              </div>
               <div v-if="flagCACP" role="tabpanel" :id="'tabpanel-' + randomId + '-2'" :aria-labelledby="'desktop-tab-' + randomId + '-2'" v-show="tabName === 2" :aria-hidden="tabName !== 2 ? 'true' : 'false'">
                <TrackingBulkPage
                  ref="bulk"
                  :filters="bulkFilters"
                  :display-filter="false">
                </TrackingBulkPage>
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import conf from '../../config/config.dev.js'
import PageOutline from '@/components/common/PageOutline.vue'
import BackButton from '@/components/common/backButton.vue'
import AppButton from '@/components/common/AppButton.vue'
import AppCard from '@/components/common/AppCard.vue'
import AppPanel from '@/components/common/AppPanel.vue'
import TrackingList from './TrackingList.vue'
import TrackingBulkPage from '@/pages/tracking/TrackingBulkPage.vue'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import alpha2Country from '../../data/alpha2Country.json'


export default {
  name: 'TrackingPage',
  components: {
    TrackingBulkPage,
    BackButton,
    TrackingList,
    'page-outline': PageOutline,
    'app-button': AppButton,
    'app-card': AppCard,
    'app-panel': AppPanel,
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    type: {
      default: 'DDV',
      type: String
    },
    id: {
      default: 'NULL',
      type: String
    }
  },
  computed: {
    tabs () {
      if (this.flagCACP){
        return [
          { value: 1, translationKey: 'Webheader.tracking_unit' },
          { value: 2, translationKey: 'Webheader.tracking_bulk' }
        ]
      }else{
        return [
          { value: 1, translationKey: 'Webheader.tracking_unit' }
        ]
      }

    },
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    fields () {
      let fields
      if (this.tabName == 1) {
        fields = [
          { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), class: 'text-center', sortable: false },
          { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
          { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
          { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
          { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
          { key: 'TestedData', label: this.$i18n.t('tracking.tested_data'), class: 'text-center', sortable: false },
          { key: 'Result', label: this.$i18n.t('tracking.maching_result'), class: 'text-center', sortable: false },
          // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: true },
          // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
          // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
          // { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: true },
        ]
      }
      else {
        fields = [
          { key: 'CreationDateRq1', label: this.$i18n.t('tracking.creation_date_request_1'), class: 'text-center', sortable: false },
          { key: 'CreationDateRp2', label: this.$i18n.t('tracking.creation_date_response_2'), class: 'text-center', sortable: false },
          { key: 'BICFrom', label: this.$i18n.t('tracking.bic_from'), class: 'text-center', sortable: false },
          { key: 'BICTo', label: this.$i18n.t('tracking.bic_to'), class: 'text-center', sortable: false },
          { key: 'IBAN', label: this.$i18n.t('tracking.iban'), class: 'text-center', sortable: false },
          { key: 'Name', label: this.$i18n.t('tracking.name'), class: 'text-center', sortable: false },
          // { key: 'CompanyName', label: this.$i18n.t('tracking.company_name'), class: 'text-center', sortable: false },
          // { key: 'Siret', label: this.$i18n.t('tracking.siret'), class: 'text-center', sortable: true },
          // { key: 'TVA', label: this.$i18n.t('tracking.tva'), class: 'text-center', sortable: true },
          { key: 'AccountType', label: this.$i18n.t('tracking.account_type'), class: 'text-center', sortable: false },
        ]
      }

      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    company_nameDirection () {
      return ((this.sortField === 'company_name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    statusVerificationDirection () {
      return ((this.sortField === 'statusVerification' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    hasInputFilter () {
      if (
          this.IBAN ||
          this.BIC ||
          this.dateBegin || this.dateEnd) {
        return true
      }
      return false
    },
    showExportButton () {
      // Show export button based on tab and permissions
      if (this.tabName === 1) {
        // For TrackingList (DDV/DDD), check if we have data and rights
        return this.flagCACP && this.$engine.firstOn().rights.rightIs('tracks_consult_extract', true)
      } else if (this.tabName === 2) {
        // For TrackingBulk, check rights
        return this.$engine.firstOn().rights.rightIs('tracks_consult_extract', true)
      }
      return false
    },
    hasBulkInputFilter () {
      if (
          this.bulkFilters.Name ||
          this.bulkFilters.dateBegin ||
          this.bulkFilters.dateEnd) {
        return true
      }
      return false
    },
    hasTrackingInputFilter () {
      if (
          this.trackingFilters.IBAN ||
          this.trackingFilters.BIC ||
          this.trackingFilters.BICFrom ||
          this.trackingFilters.BICTo ||
          this.trackingFilters.dateBegin ||
          this.trackingFilters.dateEnd ||
          this.trackingFilters.dateBeginRq2 ||
          this.trackingFilters.dateEndRq2 ||
          this.trackingFilters.dateBeginRp2 ||
          this.trackingFilters.dateEndRp2 ||
          this.trackingFilters.dateBeginRp1 ||
          this.trackingFilters.dateEndRp1 ||
          this.trackingFilters.TechStatusCode ||
          this.trackingFilters.CountryCode ||
          this.trackingFilters.MessageId ||
          this.trackingFilters.Result ||
          this.trackingFilters.ReasonCode ||
          this.trackingFilters.EntityRequestId ||
          this.trackingFilters.FileSubmissionId ||
          this.trackingFilters.ResultEntity ||
          this.trackingFilters.ReasonCodeEntity ||
          this.trackingFilters.TestCaseName ||
          this.trackingFilters.TestCaseStatus !== '') {
        return true
      }
      return false
    },
    currentFilterConfig () {
      if (this.tabName === 2) {
        return this.bulkFilterConfig
      } else {
        return this.trackingFilterConfig
      }
    },
    searchAriaLabel () {
      if (this.tabName === 2) {
        return this.$t('common.srch') + ' ' + this.$t('Webheader.tracking_bulk')
      } else {
        return this.$t('common.srch') + ' ' + this.$t('Webheader.tracking')
      }
    },
    bulkFilterConfig () {
      return [
        {
          id: 'bulk-filter-name',
          type: 'text',
          prop: 'bulkName',
          labelKey: 'tracking.file_name',
          icon: 'fa-solid fa-file',
          value: this.bulkFilters.Name,
          colSm: '12',
          colLg: '4'
        },
        {
          id: 'bulk-filter-date-begin',
          type: 'datetime',
          prop: 'bulkDateBegin',
          labelKey: 'common.date_start_label',
          icon: 'fa-solid fa-calendar',
          value: this.bulkFilters.dateBegin,
          format: 'DD/MM/YYYY H:i:s',
          maxLength: 19,
          colSm: '12',
          colLg: '4'
        },
        {
          id: 'bulk-filter-date-end',
          type: 'datetime',
          prop: 'bulkDateEnd',
          labelKey: 'common.date_end_label',
          icon: 'fa-solid fa-calendar-check',
          value: this.bulkFilters.dateEnd,
          format: 'DD/MM/YYYY H:i:s',
          maxLength: 19,
          colSm: '12',
          colLg: '4'
        },
        {
          id: 'bulk-filter-bic-entity',
          type: 'text',
          prop: 'bulkBicEntity',
          labelKey: 'tracking.bic_entity_emitter',
          icon: 'fa-solid fa-building-columns',
          value: this.bulkFilters.BicEntity,
          colSm: '12',
          colLg: '3'
        },
        {
          id: 'bulk-filter-bic-billable',
          type: 'text',
          prop: 'bulkBicBillable',
          labelKey: 'tracking.bic_billable',
          icon: 'fa-solid fa-building-columns',
          value: this.bulkFilters.BicBillable,
          colSm: '12',
          colLg: '3'
        },
        {
          id: 'bulk-filter-final-status',
          type: 'select',
          prop: 'bulkFinalStatus',
          labelKey: 'tracking.final_status',
          icon: 'fa-solid fa-check-circle',
          value: this.bulkFilters.FinalStatus,
          defaultOptionKey: 'tracking.select_final_status',
          options: [
            { value: 'PROCESSED', label: this.$t('tracking.final_status_processed') },
            { value: 'ERROR', label: this.$t('tracking.final_status_error') },
            { value: 'PARTIEL', label: this.$t('tracking.final_status_partielTraite') }
          ],
          colSm: '12',
          colLg: '3'
        },
        {
          id: 'bulk-filter-processing-state',
          type: 'select',
          prop: 'bulkProcessingState',
          labelKey: 'tracking.processing_state',
          icon: 'fa-solid fa-tasks',
          value: this.bulkFilters.StatusFile,
          defaultOptionKey: 'tracking.select_processing_state',
          options: [
            { value: '200', label: this.$t('tracking.status-200') },
            { value: '201', label: this.$t('tracking.status-201') },
            { value: '205', label: this.$t('tracking.status-205') },
            { value: '207', label: this.$t('tracking.status-207') },
            { value: '208', label: this.$t('tracking.status-208') },
            { value: '209', label: this.$t('tracking.status-209') },
            { value: '210', label: this.$t('tracking.status-210') },
            { value: '215', label: this.$t('tracking.status-215') },
            { value: '220', label: this.$t('tracking.status-220') }
          ],
          colSm: '12',
          colLg: '3'
        }
      ]
    },
    trackingFilterConfig () {
      const filters = []

      // Always show RQ1 dates first (order from 2.8)
      filters.push({
        id: 'tracking-filter-date-begin-rq1',
        type: 'datetime',
        prop: 'dateBegin',
        labelKey: !this.flagCACP
          ? 'common.date_start_label_rq1'
          : this.trackingFilters.tabName === 1
            ? 'common.date_start_label_rq1_cacp'
            : 'tracking.creation_date_start_request_1_ddd_filter',
        icon: 'fa-solid fa-calendar',
        value: this.trackingFilters.dateBegin,
        format: 'DD/MM/YYYY H:i:s',
        maxLength: 19,
        required: true,
        colSm: '6',
        colLg: '3'
      })
      filters.push({
        id: 'tracking-filter-date-end-rq1',
        type: 'datetime',
        prop: 'dateEnd',
        labelKey: !this.flagCACP
          ? 'common.date_end_label_rq1'
          : this.trackingFilters.tabName === 1
            ? 'common.date_end_label_rq1_cacp'
            : 'tracking.creation_date_end_request_1_ddd_filter',
        icon: 'fa-solid fa-calendar-check',
        value: this.trackingFilters.dateEnd,
        format: 'DD/MM/YYYY H:i:s',
        maxLength: 19,
        colSm: '6',
        colLg: '3'
      })

      // Additional filters only when panel is expanded (replicates 2.8 behaviour)
      if (!this.displayFilter) {
        return filters
      }

      // CACP-specific additional dates (RQ2/RP2) and RP1 (DDV only)
      if (this.flagCACP) {
        filters.push({
          id: 'tracking-filter-date-begin-rq2',
          type: 'datetime',
          prop: 'dateBeginRq2',
          labelKey: this.trackingFilters.tabName === 1
            ? 'common.date_start_label_rq2'
            : 'tracking.creation_date_start_request_2_ddd_filter',
          icon: 'fa-solid fa-calendar',
          value: this.trackingFilters.dateBeginRq2,
          format: 'DD/MM/YYYY H:i:s',
          maxLength: 19,
          colSm: '6',
          colLg: '3'
        })
        filters.push({
          id: 'tracking-filter-date-end-rq2',
          type: 'datetime',
          prop: 'dateEndRq2',
          labelKey: this.trackingFilters.tabName === 1
            ? 'common.date_end_label_rq2'
            : 'tracking.creation_date_end_request_2_ddd_filter',
          icon: 'fa-solid fa-calendar-check',
          value: this.trackingFilters.dateEndRq2,
          format: 'DD/MM/YYYY H:i:s',
          maxLength: 19,
          colSm: '6',
          colLg: '3'
        })
        filters.push({
          id: 'tracking-filter-date-begin-rp2',
          type: 'datetime',
          prop: 'dateBeginRp2',
          labelKey: this.trackingFilters.tabName === 1
            ? 'common.date_start_label_rp2'
            : 'tracking.creation_date_start_response_2_ddd_filter',
          icon: 'fa-solid fa-calendar',
          value: this.trackingFilters.dateBeginRp2,
          format: 'DD/MM/YYYY H:i:s',
          maxLength: 19,
          colSm: '6',
          colLg: '3'
        })
        filters.push({
          id: 'tracking-filter-date-end-rp2',
          type: 'datetime',
          prop: 'dateEndRp2',
          labelKey: this.trackingFilters.tabName === 1
            ? 'common.date_end_label_rp2'
            : 'tracking.creation_date_end_response_2_ddd_filter',
          icon: 'fa-solid fa-calendar-check',
          value: this.trackingFilters.dateEndRp2,
          format: 'DD/MM/YYYY H:i:s',
          maxLength: 19,
          colSm: '6',
          colLg: '3'
        })
        if (this.trackingFilters.tabName === 1) {
          filters.push({
            id: 'tracking-filter-date-begin-rp1',
            type: 'datetime',
            prop: 'dateBeginRp1',
            labelKey: 'common.date_start_label_rp1',
            icon: 'fa-solid fa-calendar',
            value: this.trackingFilters.dateBeginRp1,
            format: 'DD/MM/YYYY H:i:s',
            maxLength: 19,
            colSm: '6',
            colLg: '3'
          })
          filters.push({
            id: 'tracking-filter-date-end-rp1',
            type: 'datetime',
            prop: 'dateEndRp1',
            labelKey: 'common.date_end_label_rp1',
            icon: 'fa-solid fa-calendar-check',
            value: this.trackingFilters.dateEndRp1,
            format: 'DD/MM/YYYY H:i:s',
            maxLength: 19,
            colSm: '6',
            colLg: '3'
          })
        }
      }

      // VOP Provider (CACP only, DDD only)
      if (this.flagCACP && this.trackingFilters.tabName === 2) {
        filters.push({
          id: 'tracking-filter-vop-provider',
          type: 'select',
          prop: 'VopProvider',
          labelKey: 'tracking.vop_provider',
          icon: 'fa-solid fa-server',
          value: this.trackingFilters.VopProvider,
          defaultOptionKey: 'tracking.select_vop_provider',
          options: this.vopProviderList.map(v => ({ value: v.value ?? v.id, label: v.label ?? v.text })),
          colSm: '6',
          colLg: '3'
        })
      }

      // Country (CACP + DDV only)
      if (this.flagCACP && this.trackingFilters.tabName === 1) {
        filters.push({
          id: 'tracking-filter-country-code',
          type: 'select',
          prop: 'CountryCode',
          labelKey: 'tracking.flagCACP.beneficiary_bank_country',
          icon: 'fa-solid fa-globe',
          value: this.trackingFilters.CountryCode,
          defaultOptionKey: 'tracking.select_country',
          options: this.countries.map(code => ({ value: code, label: this.$t('countriesAlpha2Code.' + code) })),
          colSm: '6',
          colLg: '3'
        })
      }

      // DDV-specific additional filters (order preserved)
      if (this.trackingFilters.tabName === 1) {
        if (this.flagCACP) {
          filters.push({
            id: 'tracking-filter-file-submission-id',
            type: 'text',
            prop: 'FileSubmissionId',
            labelKey: 'tracking.flagCACP.file_submission_id',
            icon: 'fa-solid fa-file',
            value: this.trackingFilters.FileSubmissionId,
            colSm: '6',
            colLg: '3'
          })
          filters.push({
            id: 'tracking-filter-entity-request-id',
            type: 'text',
            prop: 'EntityRequestId',
            labelKey: 'tracking.flagCACP.entity_request_id',
            icon: 'fa-solid fa-id-card',
            value: this.trackingFilters.EntityRequestId,
            colSm: '6',
            colLg: '3'
          })
          filters.push({
            id: 'tracking-filter-message-id',
            type: 'text',
            prop: 'MessageId',
            labelKey: 'tracking.message_id',
            icon: 'fa-solid fa-hashtag',
            value: this.trackingFilters.MessageId,
            colSm: '6',
            colLg: '3'
          })
          filters.push({
            id: 'tracking-filter-bic-from-regex',
            type: 'text',
            prop: 'BICFromRegex',
            labelKey: 'tracking.bic_from_regex',
            icon: 'fa-solid fa-filter',
            value: this.trackingFilters.BICFromRegex,
            colSm: '6',
            colLg: '3'
          })
          filters.push({
            id: 'tracking-filter-bic-from-onus',
            type: 'switch',
            prop: 'BICFromOnus',
            labelKey: 'tracking.bic_from_onus',
            icon: 'fa-solid fa-toggle-on',
            value: this.trackingFilters.BICFromOnus,
            activeKey: 'common.active',
            inactiveKey: 'common.inactive',
            colSm: '6',
            colLg: '3'
          })
          filters.push({
            id: 'tracking-filter-bic-to-regex',
            type: 'text',
            prop: 'BICToRegex',
            labelKey: 'tracking.bic_to_regex',
            icon: 'fa-solid fa-filter',
            value: this.trackingFilters.BICToRegex,
            colSm: '6',
            colLg: '3'
          })
          filters.push({
            id: 'tracking-filter-bic-to-onus',
            type: 'switch',
            prop: 'BICToOnus',
            labelKey: 'tracking.bic_to_onus',
            icon: 'fa-solid fa-toggle-on',
            value: this.trackingFilters.BICToOnus,
            activeKey: 'common.active',
            inactiveKey: 'common.inactive',
            colSm: '6',
            colLg: '3'
          })
        }

        if (this.flagTOOLBOX) {
          filters.push({
            id: 'tracking-filter-testcase-name',
            type: 'text',
            prop: 'TestCaseName',
            labelKey: 'tracking.testcase_name',
            icon: 'fa-solid fa-vial',
            value: this.trackingFilters.TestCaseName,
            colSm: '6',
            colLg: '3'
          })
          filters.push({
            id: 'tracking-filter-testcase-status',
            type: 'select',
            prop: 'TestCaseStatus',
            labelKey: 'tracking.testcase_status',
            icon: 'fa-solid fa-vials',
            value: this.trackingFilters.TestCaseStatus,
            defaultOptionKey: 'tracking.select_testcase_status',
            options: this.testCaseStatusOptions.map(o => ({ value: o.id, label: o.text })),
            colSm: '6',
            colLg: '3'
          })
        }

        if (this.flagCACP) {
          filters.push({
            id: 'tracking-filter-result',
            type: 'select',
            prop: 'Result',
            labelKey: 'tracking.flagCACP.check_result',
            icon: 'fa-solid fa-clipboard-check',
            value: this.trackingFilters.Result,
            defaultOptionKey: 'tracking.select_result',
            options: this.resultMatchingOptions.map(o => ({ value: o.id, label: o.text })),
            colSm: '6',
            colLg: '3'
          })
          filters.push({
            id: 'tracking-filter-result-entity',
            type: 'select',
            prop: 'ResultEntity',
            labelKey: 'tracking.flagCACP.check_result_entity',
            icon: 'fa-solid fa-clipboard-check',
            value: this.trackingFilters.ResultEntity,
            defaultOptionKey: 'tracking.select_result',
            options: this.resultMatchingOptions.map(o => ({ value: o.id, label: o.text })),
            colSm: '6',
            colLg: '3'
          })
          filters.push({
            id: 'tracking-filter-reason-code',
            type: 'select',
            prop: 'ReasonCode',
            labelKey: 'tracking.flagCACP.reason_code_optional',
            icon: 'fa-solid fa-list',
            value: this.trackingFilters.ReasonCode,
            defaultOptionKey: 'tracking.flagCACP.select_reason_code',
            options: this.reasonCodeOptions.map(o => ({ value: o.id, label: o.text })),
            colSm: '6',
            colLg: '6'
          })
          // Place Tech status next to ReasonCode for better alignment (two columns of 6)
          filters.push({
            id: 'tracking-filter-tech-status-code-ddv-cacp',
            type: 'select',
            prop: 'TechStatusCode',
            labelKey: 'tracking.technical_code',
            icon: 'fa-solid fa-check-circle',
            value: this.trackingFilters.TechStatusCode,
            defaultOptionKey: 'tracking.select_status',
            options: this.techStatusOptions.map(o => ({ value: o.id, label: o.text })),
            colSm: '6',
            colLg: '6'
          })
          filters.push({
            id: 'tracking-filter-reason-code-entity',
            type: 'select',
            prop: 'ReasonCodeEntity',
            labelKey: 'tracking.flagCACP.reason_code_optional_entity',
            icon: 'fa-solid fa-list',
            value: this.trackingFilters.ReasonCodeEntity,
            defaultOptionKey: 'tracking.flagCACP.select_reason_code',
            options: this.reasonCodeEntityOptions.map(o => ({ value: o.id, label: o.text })),
            colSm: '6',
            colLg: '3'
          })
        } else {
          filters.push({
            id: 'tracking-filter-result',
            type: 'select',
            prop: 'Result',
            labelKey: 'tracking.maching_result',
            icon: 'fa-solid fa-clipboard-check',
            value: this.trackingFilters.Result,
            defaultOptionKey: 'tracking.select_result',
            options: this.resultMatchingOptions.map(o => ({ value: o.id, label: o.text })),
            colSm: '6',
            colLg: '3'
          })
        }
      }

      // DDD-specific additions (order preserved)
      if (this.trackingFilters.tabName === 2) {
        if (!this.flagCACP) {
          filters.push({
            id: 'tracking-filter-bic-from',
            type: 'text',
            prop: 'BICFrom',
            labelKey: 'tracking.bic_from',
            icon: 'fa-solid fa-building-columns',
            value: this.trackingFilters.BICFrom,
            colSm: '6',
            colLg: '3'
          })
        } else {
          filters.push({
            id: 'tracking-filter-bic-to',
            type: 'text',
            prop: 'BICTo',
            labelKey: 'tracking.bic_to',
            icon: 'fa-solid fa-building-columns',
            value: this.trackingFilters.BICTo,
            colSm: '6',
            colLg: '3'
          })
        }

        // Tech status for DDD
        filters.push({
          id: 'tracking-filter-tech-status-code',
          type: 'select',
          prop: 'TechStatusCode',
          labelKey: this.flagCACP ? 'tracking.flagCACP.demande_status' : 'tracking.technical_code',
          icon: 'fa-solid fa-check-circle',
          value: this.trackingFilters.TechStatusCode,
          defaultOptionKey: 'tracking.select_status',
          options: this.techStatusOptions.map(o => ({ value: o.id, label: o.text })),
          colSm: '6',
          colLg: '6'
        })

        if (!this.flagCACP) {
          filters.push({
            id: 'tracking-filter-iban',
            type: 'text',
            prop: 'IBAN',
            labelKey: 'tracking.iban',
            icon: 'fa-solid fa-credit-card',
            value: this.trackingFilters.IBAN,
            colSm: '6',
            colLg: '3'
          })
        } else {
          filters.push({
            id: 'tracking-filter-result-ddd',
            type: 'select',
            prop: 'Result',
            labelKey: 'tracking.result_ddd',
            icon: 'fa-solid fa-clipboard-check',
            value: this.trackingFilters.Result,
            defaultOptionKey: 'tracking.select_result',
            options: [
              { value: 'CLOSE', label: this.$t('tracking.result.account_close') },
              { value: 'OPEN', label: this.$t('tracking.result.account_open') },
              { value: 'NO_ACCOUNT', label: this.$t('tracking.result.no_account') },
              { value: 'TIMEOUT', label: this.$t('tracking.result.timeout') },
              { value: 'ERROR', label: this.$t('tracking.result.error') }
            ],
            colSm: '6',
            colLg: '3'
          })
        }
      } else if (!this.flagCACP) {
        // Tech status for DDV non-CACP (after dates)
        filters.push({
          id: 'tracking-filter-tech-status-code',
          type: 'select',
          prop: 'TechStatusCode',
          labelKey: 'tracking.technical_code',
          icon: 'fa-solid fa-check-circle',
          value: this.trackingFilters.TechStatusCode,
          defaultOptionKey: 'tracking.select_status',
          options: this.techStatusOptions.map(o => ({ value: o.id, label: o.text })),
          colSm: '6',
          colLg: '6'
        })
      }

      return filters
    }
  },
  data () {
    return {
      activateSpinner: false,
      BIC: '',
      dateBegin: '',
      dateEnd: '',
      displayFilter: true,
      filterBy: '',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      flagCACP: conf.visual === 'CACP',
      hasDefaultFilter: false,
      IBAN: '',
      identifier: '',
      idTrackAcc: '',
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      returnUrl: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      statusVerification: '',
      tabName: 1,
      technicalStatus: '',
      trackActive: '',
      TracksList: [],
      TrackType: '',
      bulkFilters: {
        Name: '',
        dateBegin: '',
        dateEnd: '',
        BicEntity: '',
        BicBillable: '',
        FinalStatus: '',
        StatusFile: ''
      },
      // Tracking List filters
      trackingFilters: {
        // Date filters
        dateBegin: '',
        dateEnd: '',
        dateBeginRq2: '',
        dateEndRq2: '',
        dateBeginRp2: '',
        dateEndRp2: '',
        dateBeginRp1: '',
        dateEndRp1: '',
        // BIC filters
        BIC: '',
        BICFrom: '',
        BICTo: '',
        BICFromRegex: '',
        BICToRegex: '',
        BICFromOnus: false,
        BICToOnus: false,
        // Other filters
        IBAN: '',
        TechStatusCode: '',
        CountryCode: '',
        MessageId: '',
        VopProvider: '',
        Result: '',
        ReasonCode: '',
        EntityRequestId: '',
        FileSubmissionId: '',
        ResultEntity: '',
        ReasonCodeEntity: '',
        // TOOLBOX specific
        TestCaseName: '',
        TestCaseStatus: '',
        // Internal tab state
        tabName: 1
      },
      // Filter options arrays
      countries: alpha2Country.countries.reverse(),
      vopProviderList: [],
      resultMatchingOptions: [
        { id: "NOAP", text: "Not Applicable" },
        { id: "MTCH", text: "Match" },
        { id: "NMTC", text: "No Match" },
        { id: "CMTC", text: "Close Match" },
        { id: "NULL", text: this.$t('tracking.no_result') }
      ],
      testCaseStatusOptions: [
        { id: "0", text: this.$t('tracking.testcase_status_list.0') },
        { id: "1", text: this.$t('tracking.testcase_status_list.1') },
        { id: "2", text: this.$t('tracking.testcase_status_list.2') },
        { id: "3", text: this.$t('tracking.testcase_status_list.3') },
        { id: "4", text: this.$t('tracking.testcase_status_list.4') }
      ],
      techStatusOptions: [
        {id: "NULL", text: this.$t("common.monitoring.success") },
        {id: "KO", text: this.$t("common.monitoring.unsuccess") }
      ],
      reasonCodeOptions: [
        {id: "9001", text: this.$t("tracking.flagCACP.reason_code_optional_list.9001") },
        {id: "9006", text: this.$t("tracking.flagCACP.reason_code_optional_list.9006") },
        {id: "9007", text: this.$t("tracking.flagCACP.reason_code_optional_list.9007") },
        {id: "9008", text: this.$t("tracking.flagCACP.reason_code_optional_list.9008") },
        {id: "9009", text: this.$t("tracking.flagCACP.reason_code_optional_list.9009") },
        {id: "9010", text: this.$t("tracking.flagCACP.reason_code_optional_list.9010") },
        {id: "9003", text: this.$t("tracking.flagCACP.reason_code_optional_list.9003") },
        {id: "9013", text: this.$t("tracking.flagCACP.reason_code_optional_list.9013") },
        {id: "9014", text: this.$t("tracking.flagCACP.reason_code_optional_list.9014") },
        {id: "9015", text: this.$t("tracking.flagCACP.reason_code_optional_list.9015") },
        {id: "9016", text: this.$t("tracking.flagCACP.reason_code_optional_list.9016") },
        {id: "9017", text: this.$t("tracking.flagCACP.reason_code_optional_list.9017") },
        {id: "9018", text: this.$t("tracking.flagCACP.reason_code_optional_list.9018") },
        {id: "9020", text: this.$t("tracking.flagCACP.reason_code_optional_list.9020") }
      ],
      reasonCodeEntityOptions: [
        {id: "NOEX", text: this.$t("tracking.flagCACP.reason_code_optional_entity_list.NOEX") },
        {id: "CLSD", text: this.$t("tracking.flagCACP.reason_code_optional_entity_list.CLSD") },
        {id: "NOAT", text: this.$t("tracking.flagCACP.reason_code_optional_entity_list.NOAT") },
        {id: "TCER", text: this.$t("tracking.flagCACP.reason_code_optional_entity_list.TCER") },
        {id: "NOAV", text: this.$t("tracking.flagCACP.reason_code_optional_entity_list.NOAV") },
        {id: "NOAS", text: this.$t("tracking.flagCACP.reason_code_optional_entity_list.NOAS") },
        {id: "FCER", text: this.$t("tracking.flagCACP.reason_code_optional_entity_list.FCER") }
      ]
    }
  },
  created () {
    this.$bus.$emit('switch-selected-menu', '/tracking/' + this.type + '/' + this.id)
    if (this.type === 'BULK'){
      this.tabName = 2
      this.displayFilter = true
    }
    if (this.type === 'DDV' || this.type === 'DDD' || this.type === 'BULKDETAILS'){
      this.tabName = 1
      this.displayFilter = false
      if (this.type !== 'BULKDETAILS') {
        this.TrackType = this.type
        // Sync trackingFilters tabName based on type
        this.trackingFilters.tabName = this.type === 'DDV' ? 1 : 2
      }
      else{
        this.TrackType = 'BULK'
        this.trackingFilters.tabName = 1
      }
    }
    // Load VOP providers if user has rights
    if (this.$engine.firstOn().rights.rightIs('vopProvider_consult', true)) {
      this.getVopProvider()
    }
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.firstOn().tracking.cleanFilterCondition()
  },
  methods: {
    onFilterChanged ({ prop, value }) {
      // Handle regular filter changes based on current tab
      if (this.tabName === 2) {
        // Bulk filters
        if (prop === 'bulkName') {
          this.bulkFilters.Name = value
        } else if (prop === 'bulkDateBegin') {
          this.bulkFilters.dateBegin = value
        } else if (prop === 'bulkDateEnd') {
          this.bulkFilters.dateEnd = value
        } else if (prop === 'bulkBicEntity') {
          this.bulkFilters.BicEntity = value
        } else if (prop === 'bulkBicBillable') {
          this.bulkFilters.BicBillable = value
        } else if (prop === 'bulkFinalStatus') {
          this.bulkFilters.FinalStatus = value
        } else if (prop === 'bulkProcessingState') {
          this.bulkFilters.StatusFile = value
        }
      } else {
        // Tracking filters
        this.trackingFilters[prop] = value
      }
    },
    clearCurrentFilters () {
      if (this.tabName === 2) {
        this.clearBulkFilterFields()
      } else {
        this.clearTrackingFilterFields()
      }
    },
    applyCurrentFilter () {
      if (this.tabName === 2) {
        this.applyBulkFilter()
      } else {
        this.applyTrackingFilter()
      }
    },
    changeTabName (tabName) {
      this.tabName = tabName

      // Ajuster l'état du filtre selon l'onglet
      // TrackingList commence avec displayFilter: false
      // TrackingBulkPage et OrphanFlux commencent avec displayFilter: true
      if (tabName === 1) {
        this.displayFilter = false
        // Sync trackingFilters tabName when in tracking unit tab
        // This affects which sub-tab (DDV=1 or DDD=2) is shown within TrackingList
        if (!this.trackingFilters.tabName) {
          this.trackingFilters.tabName = 1 // Default to DDV
        }
      } else {
        this.displayFilter = true
      }

      // Annonce du changement pour les lecteurs d'écran
      this.$nextTick(() => {
        // Try to focus on mobile or desktop tab
        const mobileTab = document.getElementById('mobile-tab-' + this.randomId + '-' + tabName)
        const desktopTab = document.getElementById('desktop-tab-' + this.randomId + '-' + tabName)

        // Focus on the visible tab (mobile has d-block d-lg-none, desktop has d-none d-lg-block)
        const activeTab = mobileTab && window.innerWidth < 992 ? mobileTab : desktopTab

        if (activeTab) {
          activeTab.focus()
          // Annonce du changement de contexte
          const announcement = document.createElement('div')
          announcement.setAttribute('role', 'status')
          announcement.setAttribute('aria-live', 'polite')
          announcement.className = 'sr-only'
          announcement.textContent = this.$t('tracking.tab_changed')
          document.body.appendChild(announcement)
          setTimeout(() => {
            document.body.removeChild(announcement)
          }, 1000)
        }
      })
    },
    toggleFilter () {
      this.displayFilter = !this.displayFilter
      // Emit event to child components
      this.$bus.$emit('toggle-filter', this.displayFilter)
    },
    refreshCurrentTab () {
      // Emit refresh event based on current tab
      if (this.tabName === 1) {
        this.$bus.$emit('refresh-tracking-list')
      } else if (this.tabName === 2) {
        this.$bus.$emit('refresh-tracking-bulk')
      }
    },
    exportCurrentTab () {
      // Emit export event based on current tab
      if (this.tabName === 1) {
        this.$bus.$emit('export-tracking-list')
      } else if (this.tabName === 2) {
        //this.$bus.$emit('export-tracking-bulk')
        this.$refs.bulk?.extractCSV?.()
      }
    },
    applyBulkFilter () {
      // Emit the filters to TrackingBulkPage component
      this.$bus.$emit('apply-filters-tracking-bulk', this.bulkFilters)
    },
    clearBulkFilterFields () {
      this.bulkFilters.Name = ''
      this.bulkFilters.dateBegin = ''
      this.bulkFilters.dateEnd = ''
      this.bulkFilters.BicEntity = ''
      this.bulkFilters.BicBillable = ''
      this.bulkFilters.FinalStatus = ''
      this.bulkFilters.StatusFile = ''
    },
    getVopProvider () {
      let params = {}
      let that = this
      this.$engine.firstOn().vopProvider.getVopProvider(params).then((resp) => {
        this.vopProviderList = resp.data.VopProvider.map(vopProvider => ({
          value: vopProvider.IdVopProvider,
          label: vopProvider.NameVopProvider
        }))
      })
      .catch(error => {
        console.error('Error loading VOP providers:', error)
      })
    },
    applyTrackingFilter () {
      // Emit the filters to TrackingList component
      this.$bus.$emit('apply-filters-tracking', this.trackingFilters)
    },
    clearTrackingFilterFields () {
      // Clear all tracking filter fields
      this.trackingFilters.dateBegin = ''
      this.trackingFilters.dateEnd = ''
      this.trackingFilters.dateBeginRq2 = ''
      this.trackingFilters.dateEndRq2 = ''
      this.trackingFilters.dateBeginRp2 = ''
      this.trackingFilters.dateEndRp2 = ''
      this.trackingFilters.dateBeginRp1 = ''
      this.trackingFilters.dateEndRp1 = ''
      this.trackingFilters.BIC = ''
      this.trackingFilters.BICFrom = ''
      this.trackingFilters.BICTo = ''
      this.trackingFilters.BICFromRegex = ''
      this.trackingFilters.BICToRegex = ''
      this.trackingFilters.BICFromOnus = false
      this.trackingFilters.BICToOnus = false
      this.trackingFilters.IBAN = ''
      this.trackingFilters.TechStatusCode = ''
      this.trackingFilters.CountryCode = ''
      this.trackingFilters.MessageId = ''
      this.trackingFilters.VopProvider = ''
      this.trackingFilters.Result = ''
      this.trackingFilters.ReasonCode = ''
      this.trackingFilters.EntityRequestId = ''
      this.trackingFilters.FileSubmissionId = ''
      this.trackingFilters.ResultEntity = ''
      this.trackingFilters.ReasonCodeEntity = ''
      this.trackingFilters.TestCaseName = ''
      this.trackingFilters.TestCaseStatus = ''
    },
    handleTabKeydown (event, tabValue) {
      // Handle arrow key navigation for tabs
      const tabs = this.tabs
      const currentIndex = tabs.findIndex(tab => tab.value === tabValue)

      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault()
        const prevIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1
        this.changeTabName(tabs[prevIndex].value)
      } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault()
        const nextIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0
        this.changeTabName(tabs[nextIndex].value)
      } else if (event.key === 'Home') {
        event.preventDefault()
        this.changeTabName(tabs[0].value)
      } else if (event.key === 'End') {
        event.preventDefault()
        this.changeTabName(tabs[tabs.length - 1].value)
      }
    }
  }
}
</script>

<style scoped>
/* Styles pour les tabs selon le guide */
.nav-tabs .nav-link {
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  color: #495057;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  white-space: nowrap;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  background-color: #e9ecef;
  border-color: #dee2e6;
  color: #495057;
}

.nav-tabs .nav-link.active {
  background-color: var(--actionButtonColor, #0a6060) !important;
  color: white !important;
  border-color: var(--actionButtonColor, #0a6060) !important;
  font-weight: bold;
}

/* Ensure desktop tab buttons have consistent styling */
.nav-tabs button.nav-link {
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  color: #495057;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.nav-tabs button.nav-link:hover,
.nav-tabs button.nav-link:focus {
  background-color: #e9ecef;
  color: #495057;
}

/* Focus visible pour l'accessibilité */
.btn:focus,
button:focus {
  outline: 3px solid #0066cc;
  outline-offset: 2px;
}

/* Style pour le contenu accessible uniquement aux lecteurs d'écran */
.sr-only {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

/* Amélioration du contraste pour les boutons sélectionnés */
.btn-selected {
  font-weight: bold;
  background-color: #0a6060 !important;
  color: #ffffff !important;
  border-color: #0a6060 !important;
}

/* Fix pour le contraste des textes dans les tabs */
::v-deep .nav-tabs .nav-link .font-weight-bold {
  color: inherit !important;
}

/* Amélioration du contraste des boutons primaires */
::v-deep .btn-primary {
  background-color: #0a6060 !important;
  border-color: #0a6060 !important;
  color: #ffffff !important;
}

::v-deep .btn-primary:hover,
::v-deep .btn-primary:focus {
  background-color: #084d4d !important;
  border-color: #084d4d !important;
}

/* Amélioration du contraste des boutons sélectionnés */
::v-deep .btn-selected {
  background-color: #0a6060 !important;
  border-color: #0a6060 !important;
  color: #ffffff !important;
}

/* Animation pour les changements d'onglets */
[role="tabpanel"] {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Filter styles */
.filter-item {
  margin-bottom: 1rem;
}

.filter-item-title {
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
}

.filter-item-content {
  display: block;
  position: relative;
}

.filter-item-input {
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.filter-item-input:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.filter-item-input-complete {
  border-color: #28a745;
}

.fixed-span-size {
  display: inline-block;
  min-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Styles des filtres inspirés de BICOnus */
.form-label {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.bg-light {
  background-color: #f8f9fa !important;
}

/* Focus avec couleur turquoise foncé */
.btn:focus,
.b-button:focus,
button:focus,
input:focus,
select:focus,
textarea:focus,
a:focus,
[tabindex]:focus {
  box-shadow: 0 0 0 0.25rem rgba(10, 96, 96, 0.25) !important;
}

/* Gutter des rows pour Bootstrap 4 */
.g-3 {
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}

.g-3 > [class*="col-"] {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.gx-2 {
  margin-right: -0.25rem;
  margin-left: -0.25rem;
}

.gx-2 > [class*="col-"] {
  padding-right: 0.25rem;
  padding-left: 0.25rem;
}
</style>
